<div class="d-flex flex-row portal__login-page">
  <div class="container login-box mx-xs-2">
    <div class="row justify-content-center" [hidden]="contentIsHidden">
      <!-- Reorder logo to top for small screens -->
      <div class="login-form col-sm-6 py-4 py-sm-5 px-4 px-lg-5 order-last order-sm-first">
        <portal-login-form></portal-login-form>
      </div>
      <div class="login-logo col-sm-6 py-4 py-sm-5 px-4 px-lg-5">
        <div class="text-center">
          <div class="logo"></div>
          @if (pageSubtitle) {
            <div class="subtitle mt-2">
              <span>{{ pageSubtitle }}</span>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
